/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './video.defs.js'
export * as $defs from './video.defs.js'
